module.exports = __webpack_public_path__ + "51999d0a962c8b18b817be1ea863ac9f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/rood.mp3
// module id = 37
// module chunks = 0